import React from 'react';

// Components

import BlockWrapper from './BlockWrapper';

const PagesTooltip = props => {
    const {
        adjustedFlow,
        changePage,
        id,
        page
    } = props;

    const handleMouseOver = (e, color = undefined) => {
        e.currentTarget.style.backgroundColor = color ? color : 'yellow';
    };

    const handleMouseLeave = (e, color = undefined) => {
        e.currentTarget.style.backgroundColor = color ? color : 'initial';
    };

    const handleMouseClick = page => changePage(page);

    return (
        <BlockWrapper
            id={id}
            additionalStyles={{
                width: 550,
                overflowY: 'auto',
                height: '460px'
            }}>
            <div>
                <div style={{ marginBottom: '10px', fontSize: '1.5rem' }}>
                    Pages and Components
                </div>
                {
                    adjustedFlow.map((el, idx) => {

                        const isCurrentPage = idx === page;
                        const currentPageHighlightColor = 'orange';

                        return (
                            <div
                                key={`${el.pageName}_${idx}`}
                                style={{
                                    position: 'relative',
                                    color: el.isActive ? 'black' : 'darkred',
                                    fontSize: '1.2rem',
                                    cursor: 'pointer',
                                    ...(isCurrentPage ? { backgroundColor: currentPageHighlightColor } : {} )
                                }}
                                onClick={() => handleMouseClick(idx)}
                                onMouseOver={handleMouseOver}
                                onMouseLeave={e => handleMouseLeave(e, isCurrentPage ? currentPageHighlightColor : 'initial')}
                            >
                                <span>
                                    { `${el.sectionIndex + 1}_${idx}` }
                                </span>
                                <span style={{ position: 'absolute', left: '30px' }}>
                                    { el.hhm === -1 ? '' : <b>{`[ ${el.hhm} ]`}</b> }
                                </span>
                                <span style={{ position: 'absolute', left: '60px' }}>
                                    { el.pageName }
                                </span>
                                <span style={{ position: 'absolute', left: '380px' }}>
                                    {
                                        el.componentName
                                    }
                                </span>
                            </div>
                        );
                    })
                }
            </div>
        </BlockWrapper>
    );
};

export default PagesTooltip;